import { TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../../mobile.setup';

const parent = Mobile.pages.statistics;
const path = 'growth';
const title = 'PAGE.MOBILE.STATISTICS.GROWTH.TITLE';

export const MobileStatisticsGrowthTab: TabPermission = PermissionsC.generateTabPermission(
  parent,
  path,
  title
);
